import React from 'react';

import CompaniesPage from '../components/CompaniesPage';

const SpecialThanks = () => (
  <CompaniesPage
    lang="en"
    title="COMP 227"
    seoDescription="Full stack development special thanks"
  />
);

export default SpecialThanks;
